var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.914062,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EAE6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3550_31401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.793 38.9141C43.559 39.7011 43.132 40.4221 42.535 41.0191L40.105 43.4491C39.508 44.0461 38.786 44.4731 37.999 44.7071V39.9141C37.999 39.3621 38.448 38.9141 38.999 38.9141H43.793ZM44 25.9141V36.9141H39C37.346 36.9141 36 38.2601 36 39.9141V44.9141H25C22.243 44.9141 20 42.6711 20 39.9141V25.9141C20 23.1571 22.243 20.9141 25 20.9141H39C41.757 20.9141 44 23.1571 44 25.9141ZM27 38.4141C27 37.5861 26.328 36.9141 25.5 36.9141C24.672 36.9141 24 37.5861 24 38.4141C24 39.2421 24.672 39.9141 25.5 39.9141C26.328 39.9141 27 39.2421 27 38.4141ZM27 32.9141C27 32.0861 26.328 31.4141 25.5 31.4141C24.672 31.4141 24 32.0861 24 32.9141C24 33.7421 24.672 34.4141 25.5 34.4141C26.328 34.4141 27 33.7421 27 32.9141ZM27 27.4141C27 26.5861 26.328 25.9141 25.5 25.9141C24.672 25.9141 24 26.5861 24 27.4141C24 28.2421 24.672 28.9141 25.5 28.9141C26.328 28.9141 27 28.2421 27 27.4141Z",
    fill: "#6F4EF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3550_31401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20.9141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon (4).c7aee8e72458de9fedb15aa38ef91e19.svg";
export { ForwardRef as ReactComponent };